var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.components.resultsNumber,{tag:"component",staticClass:"ebx-empathy-x__results-number",attrs:{"resultsNumber":_vm.numFound,"query":_vm.query}})}
var staticRenderFns = []

export { render, staticRenderFns }